import { CleanlinessRankBy } from '../../../../app/types/cleanliness-score'

export function getAuditAssignToUserList(permissionName: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/users/permission?permissionName=${permissionName}`,
  }
}

export function assignUserToAudit(
  auditObjectId: string,
  assignedToAudit: string | null,
) {
  const body = {
    assignedToAudit,
  }
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/audit/${auditObjectId}/assign-user`,
    body,
  }
}

export function assignUserToCoaching(
  auditObjectId: string,
  assignedToCoach: string | null,
) {
  const body = {
    assignedToCoach,
  }
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/audit/${auditObjectId}/assign-user`,
    body,
  }
}

export function getCleanlinessRankings(
  rankBy: CleanlinessRankBy,
  windowDays: number,
  locationObjectId: string,
) {
  const params: { [key: string]: string } = {
    rankBy,
    windowDays: windowDays.toString(),
  }
  if (locationObjectId) {
    params.locationObjectId = locationObjectId
  }
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/audit/cleanliness/rankings`,
    params,
  }
}

export function getCleanlinessSubjectDetail(
  rankBy: CleanlinessRankBy,
  subjectObjectId: string,
  windowDays: number,
) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/audit/cleanliness/${rankBy}/${subjectObjectId}`,
    params: { windowDays: windowDays.toString() },
  }
}
